import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { StockCounters } from 'src/app/models/types/Product/Stock.type';

@Component({
  selector: 'app-stock-button',
  imports: [TranslateModule],
  templateUrl: './stock-button.component.html',
  styleUrl: './stock-button.component.scss'
})
export class StockButtonComponent {

  @Input('placeholder') placeholder!: boolean;
  @Input('isTotal') isTotal: boolean = false;
  @Input('strapView') strapView: boolean = false;
  @Input('text') text?: string;
  @Input('counters') counters: StockCounters = {
    free: 0,
    reservation: 0,
    consignmentIn: 0,
    inTransit: 0,
  }

  @Output('handleClick') handleClick: EventEmitter<void> = new EventEmitter();

}
